// src/api/AxiosApiCall.js
import axios from "axios";
import CryptoJS from "crypto-js";

// Create Axios instance
const axiosInstance = axios.create();

const AxiosApiCall = () => {
    // AES Encryption
    const encryptData = (data) => {
        // console.log(data)
        const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;
        const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_IV_KEY);

        const encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            CryptoJS.enc.Utf8.parse(secretKey),
            {
                iv: iv,
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC,
            }
        );

        return encrypted.toString();
    };

    // Add request interceptor
    axiosInstance.interceptors.request.use(
        (config) => {
            // Add authorization header
            const authData = JSON.parse(localStorage.getItem("auth") || "{}");
            if (authData?.token) {
                config.headers.Authorization = `Bearer ${authData.token}`;
            }

            const isEncryptionEnabled =
                process.env.REACT_APP_ENCRYPTION_ENABLED === "true";

            const isModifyingMethod = ["post", "put", "delete", "patch"].includes(
                config.method?.toLowerCase()
            );

            // Handle encrypted request
            if (
                isEncryptionEnabled &&
                isModifyingMethod &&
                config.data &&
                !config.data._isEncrypted
            ) {
                if (config.data instanceof FormData) {
                    // Not encrypting, but still sending FormData
                    config.headers["Content-Type"] = "multipart/form-data";
                } else {
                    // Encrypt plain object
                    const encryptedData = encryptData(config.data);
                    config.data = {
                        request_data: encryptedData,
                        _isEncrypted: true,
                    };
                    config.headers["Content-Type"] = "application/json";
                }
            } else if (config.data instanceof FormData) {
                // Not encrypting, but still sending FormData
                config.headers["Content-Type"] = "multipart/form-data";
            } else {
                config.headers["Content-Type"] = "application/json";
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    return axiosInstance;
};

export default AxiosApiCall;
